import {
  FETCH_ASSESSMENT,
  FETCH_ASSESSMENT_SUCCESS,
  FETCH_ASSESSMENT_FAILURE,
  FETCH_ASSESSMENTS,
  FETCH_ASSESSMENTS_SUCCESS,
  FETCH_ASSESSMENTS_FAILURE,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_FAILURE,
  COUNT_ASSESSMENTS,
  COUNT_ASSESSMENTS_SUCCESS,
  COUNT_ASSESSMENTS_FAILURE,
  CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_FAILURE,
} from "./actionTypes";

// Fetch Assessments
export const fetchAssessments = () => ({
  type: FETCH_ASSESSMENTS,
});

export const fetchAssessmentsSuccess = (assessments) => ({
  type: FETCH_ASSESSMENTS_SUCCESS,
  payload: assessments,
});

export const fetchAssessmentsFailure = (error) => ({
  type: FETCH_ASSESSMENTS_FAILURE,
  payload: error,
});

// Fetch Assessment
export const fetchAssessment = (assessmentId) => ({
  type: FETCH_ASSESSMENT,
  payload: assessmentId,
});

export const fetchAssessmentSuccess = (assessment) => ({
  type: FETCH_ASSESSMENT_SUCCESS,
  payload: assessment,
});

export const fetchAssessmentFailure = (error) => ({
  type: FETCH_ASSESSMENT_FAILURE,
  payload: error,
});

// Delete Assessment
export const deleteAssessment = (assessmentId) => ({
  type: DELETE_ASSESSMENT,
  payload: assessmentId,
});

export const deleteAssessmentSuccess = (assessment) => ({
  type: DELETE_ASSESSMENT_SUCCESS,
  payload: assessment,
});

export const deleteAssessmentFailure = (error) => ({
  type: DELETE_ASSESSMENT_FAILURE,
  payload: error,
});

export const countAssessments = () => ({
  type: COUNT_ASSESSMENTS,
});

export const countAssessmentsSuccess = (count) => ({
  type: COUNT_ASSESSMENTS_SUCCESS,
  payload: count,
});

export const countAssessmentsFailure = (error) => ({
  type: COUNT_ASSESSMENTS_FAILURE,
  payload: error,
});

// Create Assessment
export const createAssessment = (assessment) => ({
  type: CREATE_ASSESSMENT,
  payload: assessment,
});

export const createAssessmentSuccess = (assessment) => ({
  type: CREATE_ASSESSMENT_SUCCESS,
  payload: assessment,
});

export const createAssessmentFailure = (error) => ({
  type: CREATE_ASSESSMENT_FAILURE,
  payload: error,
});
